import React from "react";
import { useWebData } from "../../Context/webDataContext";
import defaultLeftImage from "../homeScreens/img2.svg";
import defaultRightImage from "../homeScreens/img1.svg";
import defaultVector from "../homeScreens/vector.svg";
import { resolvePlayStoreUrl } from "../../constants/storeLinks";

// Default badges
const defaultGooglePlayBadge =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/512px-Google_Play_Store_badge_EN.svg.png";
const defaultAppStoreBadge =
  "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg";

function GetStartedBanner() {
  const { getGetStartedData } = useWebData();
  const data = getGetStartedData();

  const {
    title = "Get started with MaidEaze",
    subtitle = "Best Helping Hands For You!",
    googlePlayLink: rawGooglePlayLink,
    appStoreLink = "#",
    leftImage,
    rightImage,
    vectorLeft,
    vectorRight,
  } = data || {};

  const googlePlayLink = resolvePlayStoreUrl(rawGooglePlayLink);

  return (
    <section className="lg:py-10 bg-white">
      <div className="">
        <div
          className="
            relative
            w-full
            rounded-2xl
            lg:rounded-4xl
            min-h-[300px]
            flex flex-col items-center justify-center
            overflow-hidden
          "
          style={{
            background:
              "radial-gradient(circle at 30% 50%, #1D9D67 0%, #1E8157 21%, #1F6546 50%, #1F573E 70%, #204533 100%)",
          }}
        >
          {/* Left Phone Image */}
          <img
            src={leftImage || defaultLeftImage}
            alt="Left phone"
            className="hidden lg:block absolute left-10 -translate-x-1/4 top-0 max-h-[260px] rounded-md drop-shadow-xl"
          />

          {/* Left Vector */}
          <img
            src={vectorLeft || defaultVector}
            alt="Vector Left"
            className="hidden lg:block absolute left-10 -translate-x-1/4 top-0 max-h-[260px] rounded-md drop-shadow-xl"
          />

          {/* Right Phone Image */}
          <img
            src={rightImage || defaultRightImage}
            alt="Right phone"
            className="hidden lg:block absolute right-16 translate-x-1/4 bottom-0 max-h-[260px] rounded-md drop-shadow-xl"
          />

          {/* Right Vector */}
          <img
            src={vectorRight || defaultVector}
            alt="Vector Right"
            className="hidden lg:block absolute right-0 -translate-x-1/4 bottom-0 max-h-[260px] rounded-md drop-shadow-xl"
          />

          {/* Center Content */}
          <div className="relative z-10 text-center px-4 py-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
              {title}
            </h2>
            <p className="text-white opacity-90 text-base md:text-lg mb-6">
              {subtitle}
            </p>

            {/* Store Badges */}
            <div className="flex flex-wrap justify-center items-center gap-4">
              <a
                href={googlePlayLink}
                aria-label="Download on Google Play"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={defaultGooglePlayBadge}
                  alt="Google Play Store"
                  className="h-12 object-contain"
                />
              </a>
              <a
                href={appStoreLink}
                aria-label="Download on the App Store"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={defaultAppStoreBadge}
                  alt="Apple App Store"
                  className="h-12 object-contain"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GetStartedBanner;
